function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".search-1{fill:current;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "search-1",
  d: "M1.17,5.85A3.3,3.3,0,0,1,5.83,1.19a3.23,3.23,0,0,1,.5,4,.13.13,0,0,0,0,.16L8,7a.78.78,0,0,1,.12,1.1l-.06.06A.78.78,0,0,1,7,8.05L5.32,6.37a.14.14,0,0,0-.17,0A3.25,3.25,0,0,1,1.17,5.85Zm4.05-.61a2.44,2.44,0,1,0-3.44,0A2.44,2.44,0,0,0,5.22,5.24Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "search-1",
  d: "M5,3.32a.35.35,0,0,0,.14,0,.34.34,0,0,0,.18-.44A2.15,2.15,0,0,0,2.52,1.71a.34.34,0,0,0-.18.44.32.32,0,0,0,.44.18,1.47,1.47,0,0,1,1.92.78A.35.35,0,0,0,5,3.32Z"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 8.47 8.47",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.20f8f2d5.svg";
export { ForwardRef as ReactComponent };